// Fork. After the line's first move, the piece that moved attacks two or
// more enemy pieces it would win: the king, a piece worth more than itself,
// or one nobody defends. Pawns are not targets. The forking piece is safe
// where it stands (a knight on c7 the king can take forks nothing). The
// variation names the forking piece: a knight, a pawn, a bishop, a rook,
// the queen or the king.
import type { Motif } from '@chess/api-mistakes';
import type { TacticLine } from './line.ts';
import { moved, safe, winnable } from './rays.ts';

export function fork(line: TacticLine): Motif | undefined {
  const first = line.pv[0];
  const m = first ? moved(line.board, first) : undefined;
  if (!m || !safe(m.after, m.to)) return undefined;
  const targets = m.after.attacksFrom(m.to).filter((sq) => {
    const p = m.after.get(sq);
    return !!p && p.colour === line.victim && p.kind !== 'pawn' && winnable(m.after, sq, m.piece.kind);
  });
  return targets.length >= 2 ? { family: 'fork', variation: m.piece.kind } : undefined;
}
